// check if it is iphone
export const checkIphone = () => {
    const u = navigator.userAgent;
    const isIphone = u.indexOf('iPhone') > -1;
    return isIphone;
    };